/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/121-quotes-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M12.5 10A3.5 3.5 0 1116 6.5l.016.5a7 7 0 01-7 7v-2a4.97 4.97 0 003.536-1.464 5.01 5.01 0 00.497-.578 3.547 3.547 0 01-.549.043zm-9 0A3.5 3.5 0 117 6.5l.016.5a7 7 0 01-7 7v-2a4.97 4.97 0 003.536-1.464 5.01 5.01 0 00.497-.578 3.547 3.547 0 01-.549.043z"/>'
  }
})
